import { mapActions, mapGetters } from 'vuex';


/**
 * Helper mixin that checks if the user is connected with Xero.'
 * This guard is made as a mixin because we need to fetch data before checking.
 * Therefore, this can't be on the router level.
 */
export default {
  computed: {
    ...mapGetters('entities/users', ['isVenueXeroConnected']),
  },
  methods: {
    ...mapActions('entities/users', ['initVenueLoggedUser']),
  },
  async created() {
    await this.initVenueLoggedUser({ venueId: this.venueId ?? Number(this.$route.params.id) });
    if (!this.isVenueXeroConnected) {
      this.$router.replace({
        name: 'venue-xero-not-connected',
        params: {
          flash: {
            title: 'You are not connected to Xero.',
            type: 'fail',
          },
        },
      });
    }
  },
};
